/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

//TODO:
require('./src/styles/global.css');

exports.shouldUpdateScroll = () => {
  if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
    return false;
  }
  window.scrollTo(0, 0);

  return false;
};

exports.onClientEntry = async () => {
  if (typeof IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
};

exports.onRouteUpdate = ({ location }) => {
  const pageHasReprise = ['/fullstory-platform-tour/', 'resources'].some((page) => location.pathname.includes(page));
  window['_fs_run_in_iframe'] = pageHasReprise;
};
